<template>
  <div>
    <v-row
      align="center"
      v-for="(assignment, index) in value.examinationAssignments"
      :key="index"
    >
      <v-col cols="10" cols-md="11">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-select
                  v-model="assignment.examination"
                  :items="examinationOrderDataMap"
                  :loading="allExaminationsPending"
                  :label="$t('examination.examination')"
                  :rules="config.rules"
                  dense
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="assignment.interval"
                  :items="months"
                  :rules="config.rules"
                  :label="$t('employeeGroup.selectInterval')"
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" cols-md="1">
        <v-btn
          icon
          color="error"
          @click="removeExaminationAssignment(index)"
          data-cy="remove"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-btn text dense @click="addExaminationAssignment" class="mt-4">
      {{ $t("employeeGroup.addExaminationAssignment") }}
    </v-btn>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["value", "config"],
  components: {},
  data: () => ({
    examinationAssigmentsCount: 2,
    standardOpenExamination: { value: "" },
  }),
  computed: {
    ...mapGetters(["allExaminations", "allExaminationsPending"]),
    examinationOrderDataMap() {
      return this.allExaminations.map((examination) => {
        const Description = examination.name;
        const id = examination._id;
        return Object.assign({}, examination, {
          text: Description,
          value: id,
        });
      });
    },
    months() {
      return [
        { value: 1, text: this.$tc("employeeGroup.month", 1, { count: 1 }) },
        { value: 2, text: this.$tc("employeeGroup.month", 2, { count: 2 }) },
        { value: 3, text: this.$tc("employeeGroup.month", 3, { count: 3 }) },
        { value: 4, text: this.$tc("employeeGroup.month", 4, { count: 4 }) },
        { value: 5, text: this.$tc("employeeGroup.month", 5, { count: 5 }) },
        { value: 6, text: this.$tc("employeeGroup.month", 6, { count: 6 }) },
        { value: 7, text: this.$tc("employeeGroup.month", 7, { count: 7 }) },
        { value: 8, text: this.$tc("employeeGroup.month", 8, { count: 8 }) },
        { value: 9, text: this.$tc("employeeGroup.month", 9, { count: 9 }) },
        { value: 10, text: this.$tc("employeeGroup.month", 10, { count: 10 }) },
        { value: 11, text: this.$tc("employeeGroup.month", 11, { count: 11 }) },
        { value: 12, text: this.$tc("employeeGroup.month", 12, { count: 12 }) },
        { value: 18, text: this.$tc("employeeGroup.month", 18, { count: 18 }) },
        { value: 24, text: this.$tc("employeeGroup.month", 24, { count: 24 }) },
        { value: 36, text: this.$tc("employeeGroup.month", 36, { count: 36 }) },
      ];
    },
  },
  created() {
    this.$store.dispatch("getAllExaminations");
  },
  methods: {
    addExaminationAssignment() {
      this.value.examinationAssignments.push({
        examination: null,
        interval: 11,
      });
    },
    removeExaminationAssignment(index) {
      this.value.examinationAssignments.splice(index, 1);
    },
  },
};
</script>
